export default {}


// WEBPACK FOOTER //
// ./src/lang/en.js